import { render } from "./AssignementsSubmitted.vue?vue&type=template&id=a32d74f6&scoped=true"
import script from "./AssignementsSubmitted.vue?vue&type=script&lang=js"
export * from "./AssignementsSubmitted.vue?vue&type=script&lang=js"

import "./AssignementsSubmitted.vue?vue&type=style&index=0&id=a32d74f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32d74f6"]])

export default __exports__